export default __webpack_public_path__ + "static/media/Bruce Leon.2ad4ba4f.jpg";